import { IScoreSubRoot } from '@discngine/moosa-models';

export const selectScores = (state: IScoreSubRoot) => state.scores.values;
export const selectScoredDataset = (state: IScoreSubRoot) =>
  state.scores.scoredDataset ?? {};
export const selectComparisonScores = (state: IScoreSubRoot) =>
  state.scores.comparisonValues;
